module.exports = __webpack_public_path__ + "img/warning.09619e3d.svg";